/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SubscriptionConfig { 
    /**
     * Whether Paid pilot was activated during deployment
     */
    paid_pilot?: boolean;
    seller?: string;
    /**
     * Whether TERM subscription is activated in given geo
     */
    term_subscription?: boolean;
}

